exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "td{color:#757575!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-91d3ecbc","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/pages/superconciergerie/tabs/FacturationTab.vue
// module id = 1143
// module chunks = 0